import { render } from "./SubLinkNave.vue?vue&type=template&id=06842764&scoped=true"
import script from "./SubLinkNave.vue?vue&type=script&lang=js"
export * from "./SubLinkNave.vue?vue&type=script&lang=js"

import "./SubLinkNave.vue?vue&type=style&index=0&id=06842764&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06842764"]])

export default __exports__